import { Link } from 'react-router-dom';
import { useAppData } from '../context/AppDataContext.jsx';
import MedIntakeRow from '../components/MedIntakeRow.jsx';
import { PHASE_LABEL } from '../phases.js';

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

function formatDateIT(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
}

function formatDateShortIT(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long' });
}

export default function HomePage() {
  const { phase, todayMeds, episodes, periods, addEpisode, cycleStats } = useAppData();
  const today = todayISO();
  const todaysHeadaches = episodes.filter((e) => e.date === today);

  async function quickHeadache(intensity) {
    await addEpisode({
      date: today,
      intensity,
      type: 'altro',
      note: '',
    });
  }

  const lastPeriod = periods[0];

  return (
    <div>
      <div className="card">
        <div className="muted">{formatDateIT(today)}</div>
        <h2 style={{ marginTop: '0.25rem' }}>
          Fase: {PHASE_LABEL[phase.phase] || '—'}
        </h2>
        {phase.dayOfCycle && (
          <div className="muted">
            Giorno {phase.dayOfCycle} del ciclo (lunghezza media {phase.cycleLength}g)
          </div>
        )}
        {cycleStats?.nextPeriodEstimate && (
          <div className="muted" style={{ marginTop: '0.5rem' }}>
            Prossimo ciclo previsto: <strong>{formatDateShortIT(cycleStats.nextPeriodEstimate)}</strong>
            {' · '}
            Ovulazione prevista: <strong>{formatDateShortIT(cycleStats.nextOvulationEstimate)}</strong>
          </div>
        )}
        {cycleStats?.fertileWindowEstimate && (
          <div className="muted">
            Finestra fertile prevista: {formatDateShortIT(cycleStats.fertileWindowEstimate.from)}
            {' – '}{formatDateShortIT(cycleStats.fertileWindowEstimate.to)}
          </div>
        )}
        {!lastPeriod && (
          <p>
            Non hai ancora registrato nessun ciclo. <Link to="/ciclo">Aggiungi il primo periodo</Link>.
          </p>
        )}
      </div>

      <div className="card">
        <h2>Medicine di oggi</h2>
        {todayMeds.items.length === 0 ? (
          <p className="muted">
            Non hai ancora medicine impostate.{' '}
            <Link to="/medicine">Aggiungile qui</Link>.
          </p>
        ) : (
          <div>
            {todayMeds.items.map(({ med, intakes }) => (
              <MedIntakeRow
                key={med.id}
                med={med}
                intakes={intakes}
                date={today}
              />
            ))}
            <p className="muted" style={{ marginTop: '0.5rem' }}>
              Tocca <strong>+ ora</strong> per registrare l'assunzione adesso, o{' '}
              <strong>+…</strong> per scegliere un orario diverso.
            </p>
          </div>
        )}
      </div>

      <div className="card">
        <h2>Mal di testa di oggi</h2>
        {todaysHeadaches.length > 0 ? (
          <ul className="list">
            {todaysHeadaches.map((e) => (
              <li key={e.id}>
                Intensit&agrave; {e.intensity}/10 · {e.type}
                {e.note && <div className="muted">{e.note}</div>}
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">Nessun mal di testa registrato oggi.</p>
        )}
        <div className="row" style={{ marginTop: '0.5rem' }}>
          <button className="secondary" onClick={() => quickHeadache(3)}>+ Lieve</button>
          <button className="secondary" onClick={() => quickHeadache(6)}>+ Medio</button>
          <button onClick={() => quickHeadache(9)}>+ Forte</button>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <Link to="/mal-di-testa">Aggiungi con dettagli &rarr;</Link>
        </div>
      </div>
    </div>
  );
}
